import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getContributionsPageData } from './api';
import type { ContributionsPageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: ContributionsPageDataContext,
	Provider: ContributionsPageDataContextProvider,
	useContext: useContributionsPageData,
	useAsyncData: useContributionsPageDataFromApi,
	prefetchAsyncData: prefetchContributionsPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'ContributionsPageDataContext',
	dataProperty: 'pageData',
	getData: getContributionsPageData,
	errorHandler: pageDataErrorHandler<ContributionsPageDataErrorCode>(),
});
